// Quelle application le praticien a-t-il demandee ?
//
// Elle est portee par le NOM DE DOMAINE d'entree, pas par un ecran de choix :
//
//   login.fisi.fr     -> aucune application imposee, l'ecran "Choix de l'application" sert
//   ag2035.fisi.fr    -> AG2035 (comptabilite), instance externe
//   transcam.fisi.fr  -> TransCAM, servi par le portail lui-meme
//
// Les trois pointent sur la meme machine et le meme backend ; seul le vhost change.
// C'est ce code d'application qui est envoye au backend, et c'est lui qui determine
// sur quel parc de serveurs le client est cherche (table serveurs.appli).

const APPLIS = {
    ag2035: {
        code: "ag2035",
        libelle: "Comptabilite AG2035",
        // AG2035 a sa PROPRE interface, servie par l'instance du client
        // (ag2035.<n>.fisi.fr). Apres authentification, on quitte le portail.
        redirigeVersInstance: true,
        // Chemin d'atterrissage de cette interface, qui echange le ticket contre
        // une session. Cf. AGWeb : frontend/src/pages/connexion/EntreePortail.tsx
        cheminEntree: "/entree"
    },
    transcam: {
        code: "transcam",
        libelle: "TransCAM",
        // TransCAM n'a pas d'interface propre : c'est CE portail qui l'affiche, et il
        // appelle l'instance (BackEndFInal, /final/) en arriere-plan. Aucune redirection,
        // et donc aucun ticket a suivre.
        redirigeVersInstance: false,
        cheminEntree: null
    }
};

// Application imposee par le domaine courant, ou null si le domaine n'en impose pas.
export function appliDuDomaine() {
    if (typeof window === "undefined") return null;

    const hote = (window.location.hostname || "").toLowerCase();
    const premierNiveau = hote.split(".")[0];

    return APPLIS[premierNiveau] || null;
}

// Code a transmettre au backend. null = le backend applique son defaut historique,
// et rien ne change pour les appels existants depuis login.fisi.fr.
export function codeAppliDemandee() {
    const appli = appliDuDomaine();
    return appli ? appli.code : null;
}

export default APPLIS;
